/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_04_Detail_Amateur_1_HeadingInputs */

const en_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How this holds up over eighteen holes`)
};

const es_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo se sostiene a lo largo de dieciocho hoyos`)
};

const de_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie das über achtzehn Löcher hält`)
};

const zh_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`十八洞下来效果如何`)
};

const ar_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كيف يصمد هذا عبر ثماني عشرة حفرة`)
};

const fr_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment cela tient sur dix-huit trous`)
};

const vi_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cách điều này đứng vững qua mười tám lỗ`)
};

const sw_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jinsi inavyodumu katika mashimo kumi na nane`)
};

const th_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผลที่เห็นตลอดสิบแปดหลุม`)
};

const bs_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kako se ovo drži kroz osamnaest rupa`)
};

const ja_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18ホールを通してどう持ちこたえるか`)
};

const ko_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18홀 내내 어떻게 버티는가`)
};

const pt_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como isso se sustenta ao longo de dezoito buracos`)
};

const it_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come regge per diciotto buche`)
};

const sv_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hur det håller över arton hål`)
};

const nl_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe dit standhoudt over achttien holes`)
};

const da_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sådan holder det over atten huller`)
};

const nb_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slik holder det over atten hull`)
};

const fi_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miten tämä kestää kahdeksantoista reikää`)
};

const pl_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak to się sprawdza przez osiemnaście dołków`)
};

const ru_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как это работает на протяжении восемнадцати лунок`)
};

const tr_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On sekiz delik boyunca nasıl dayanır`)
};

const hi_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अठारह होल तक यह कैसे टिकता है`)
};

const id_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagaimana hal ini bertahan sepanjang delapan belas hole`)
};

const ms_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagaimana ia bertahan sepanjang lapan belas lubang`)
};

const cs_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak to obstojí během osmnácti jamek`)
};

const el_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πώς αντέχει αυτό σε δεκαοκτώ τρύπες`)
};

const he_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`איך זה מחזיק לאורך שמונה עשרה גומות`)
};

const af_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe dit oor agtien putjies hou`)
};

const hu_method_content_step_04_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hogyan bírja ez tizennyolc lyukon át`)
};

/**
* | output |
* | --- |
* | "How this holds up over eighteen holes" |
*
* @param {Method_Content_Step_04_Detail_Amateur_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_04_detail_amateur_1_heading = /** @type {((inputs?: Method_Content_Step_04_Detail_Amateur_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_04_Detail_Amateur_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "de") return de_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "th") return th_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "it") return it_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "da") return da_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "id") return id_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "el") return el_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "he") return he_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "af") return af_method_content_step_04_detail_amateur_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_04_detail_amateur_1_heading(inputs)
	return en_method_content_step_04_detail_amateur_1_heading(inputs)
});